"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function YourJourneyToBalanceStartsHere() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: illustrationRef,
    isVisible: illustrationVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="1396" id="your-journey-to-balance-starts-here" className="relative bg-background overflow-hidden">
      <div className="relative max-w-[1320px] mx-auto px-8 md:px-12 lg:px-16 py-32 md:py-44">
        <span aria-hidden="true" className="absolute top-16 left-4 md:left-8 w-2 h-2 border-t border-l border-secondary"></span>
        <span aria-hidden="true" className="absolute top-16 left-4 md:left-8 w-2 h-2 border-t border-l border-secondary" style={{
        transform: "translate(6px, 6px)"
      }}></span>
        <span aria-hidden="true" className="absolute top-16 right-4 md:right-8 w-2 h-2 border-t border-r border-secondary"></span>
        <span aria-hidden="true" className="absolute bottom-16 left-4 md:left-8 w-2 h-2 border-b border-l border-secondary"></span>
        <span aria-hidden="true" className="absolute bottom-16 right-4 md:right-8 w-2 h-2 border-b border-r border-secondary"></span>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          <div ref={headlineRef} className="lg:col-span-7 relative order-2 lg:order-1">
            <div className="hidden lg:flex absolute -left-4 top-0 bottom-0 flex-col items-center justify-start gap-3" style={{
            writingMode: "vertical-rl"
          }}>
              <span className="font-mono text-xs uppercase text-foreground" style={{
              letterSpacing: '0.22em'
            }}></span>
              <span className="font-mono text-xs uppercase text-secondary" style={{
              letterSpacing: '0.22em'
            }}><br /></span>
            </div>

            <div className="!text-[rgba(125,92,204,1)] lg:pl-12">
              <h1 className="font-default text-purple-800" style={{
              fontSize: "clamp(2.75rem, 6.4vw, 6.25rem)",
              lineHeight: 0.98,
              letterSpacing: "-0.03em",
              fontWeight: 200
            }}>
                <span className="block transition-all" style={{
                transitionDuration: '720ms',
                transitionTimingFunction: 'cubic-bezier(0.22, 1, 0.36, 1)',
                transform: 'translateY(0px)',
                opacity: '1',
                transitionDelay: '0ms'
              }}>
                  Discover, embrace, and step into your true potential.
                </span>
              </h1>

              <div className="flex items-center gap-6 mt-10 mb-8 transition-all" style={{
              transitionDuration: "720ms",
              transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
              transform: headlineVisible ? "translateY(0)" : "translateY(16px)",
              opacity: headlineVisible ? 1 : 0,
              transitionDelay: "240ms"
            }}>
                <span className="h-px bg-secondary/60 w-16 flex-shrink-0"></span>
                <span className="font-mono text-xs uppercase text-foreground" style={{
                letterSpacing: "0.16em"
              }}>
                  10+ Years — Clinical Care
                </span>
                <span className="h-px bg-secondary/60 flex-1 relative">
                  <span className="absolute right-0 top-1/2 -translate-y-1/2 w-1.5 h-1.5 rounded-lg" style={{
                  background: "var(--ring)"
                }}></span>
                </span>
              </div>

              <p className="text-foreground/80 max-w-[480px] transition-all" style={{
              fontSize: "clamp(0.9375rem, 1.05vw, 1.0625rem)",
              lineHeight: 1.65,
              fontWeight: 350,
              transitionDuration: "720ms",
              transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
              transform: headlineVisible ? "translateY(0)" : "translateY(16px)",
              opacity: headlineVisible ? 1 : 0,
              transitionDelay: "320ms"
            }}>
                TR Mental Health provides compassionate therapy for anxiety, trauma, and life transitions. Together, we will navigate your challenges, resolve what holds you back, and help you reclaim the meaningful life you deserve. You are not alone in this journey.
              </p>

              
            </div>
          </div>

          <div ref={illustrationRef} className="lg:col-span-5 relative order-1 lg:order-2 transition-all" style={{
          transitionDuration: "720ms",
          transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
          transform: illustrationVisible ? "translateY(0)" : "translateY(16px)",
          opacity: illustrationVisible ? 1 : 0,
          transitionDelay: "160ms"
        }}>
            <div className="relative w-full max-w-[480px] mx-auto">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699238/img/therapeutic_healing_journey_illustration.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699238/img/therapeutic_healing_journey_illustration.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699238/img/therapeutic_healing_journey_illustration.png-wvc-sizes" alt="Abstract illustration representing emotional balance and therapeutic growth" className="w-full h-auto block" loading="lazy" decoding="async" />
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-[1320px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="h-px bg-secondary/40"></div>
      </div>
    </section>;
}